/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ValidateUtils } from 'app/shared/utils';

export class ProgramDashboardToken { 
    name: string;
    vizUrl: string;
    /**
     * Complete browser sign-out URL. POST empty JSON with credentials included and no authorization header. Uses API 3.27 or later independently of the service REST version.
     */
    signOutUrl: string;
    token: string;

    constructor(item?: Partial<ProgramDashboardToken>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            name: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.name : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            vizUrl: {
                type: 'uri',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.vizUrl : itemOrValue;

                    if (itemOrValue?.vizUrl != null) {
                        if (itemOrValue.vizUrl === '') {
                            itemOrValue.vizUrl = undefined;
                        } else if (['int32', 'int64'].indexOf('uri') >= 0) {
                            itemOrValue.vizUrl = parseInt(itemOrValue.vizUrl.toString(), 10);
                        } else if (['float'].indexOf('uri') >= 0) {
                            itemOrValue.vizUrl = parseFloat(itemOrValue.vizUrl.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uri');
                    if (['uuid'].indexOf('uri') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            signOutUrl: {
                type: 'uri',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.signOutUrl : itemOrValue;

                    if (itemOrValue?.signOutUrl != null) {
                        if (itemOrValue.signOutUrl === '') {
                            itemOrValue.signOutUrl = undefined;
                        } else if (['int32', 'int64'].indexOf('uri') >= 0) {
                            itemOrValue.signOutUrl = parseInt(itemOrValue.signOutUrl.toString(), 10);
                        } else if (['float'].indexOf('uri') >= 0) {
                            itemOrValue.signOutUrl = parseFloat(itemOrValue.signOutUrl.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uri');
                    if (['uuid'].indexOf('uri') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            token: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.token : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramDashboardToken.isValid,
        };
    }

    static isValid(obj: ProgramDashboardToken): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramDashboardToken.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.name.isValid(item);
            result = result && validationObject.vizUrl.isValid(item);
            result = result && validationObject.signOutUrl.isValid(item);
            result = result && validationObject.token.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

